export default __webpack_public_path__ + "static/media/jesse.cb0a2a1a.jpeg";